module.exports = __webpack_public_path__ + "static/media/JakeKnowlton.491e2236.png";